export default __webpack_public_path__ + "static/media/call-a-person-search-img.8605b56e.svg";